import { Box, Modal, Typography } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getMyTrips } from "../../../api/group";
import { getGroupAreas } from "../../../api/jahadgar";
import hospital from "../../../assets/image/hospital.png";
import GroupTableOnline from "./groupTableOnline";

export default function AddDrugInAreaPop({
  open,
  setOpen,
  setDataDrugSelect,
  dataDrugSelect,
  equipment,
  notGroup,
}) {
  const [dataGroups, setDataGroups] = useState();
  const handleClose = () => {
    // setShow(false);
    setOpen(false);
  };
  useEffect(() => {
    if (open === true) {
      if (notGroup) {
        getGroupAreas()
          .then((x) => setDataGroups(x))
          .catch((z) => console.log(z));
      } else {
        getMyTrips("?status=IN_PROGRESS")
          .then((x) => setDataGroups(x))
          .catch((z) => console.log(z));
      }
    }
  }, [open]);
  // console.log(dataDrugSelect);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      //   sx={{}}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "60vw",
          height: "20vw",
          bgcolor: "white",
          minWidth:"900px",
          minHeight:"350px",
          boxShadow: 24,
          p: 5,
          borderRadius: "23px",
          ":focus-visible": {
            outline: "none !important",
            border: "none !important",
          },
        }}
      >
        <Box display="flex" alignItems="center" gap="20px">
          <Box width="40%"  borderLeft="1px solid #98C2CB" height={"350px"}>
            <img src={hospital} />
          </Box>
          <Box width={"60%"} display="" height="350px">
            <Typography fontSize={"18px"} fontWeight="bold">
              گروه‌هایی که در هفته آینده اردو برگذار میکنند
            </Typography>
            <Box
              mt="20px"
              height={"18vw"}
              minHeight="310px"
              width="100%"
              boxShadow="0px 4px 4px 0px #00000040"
              borderRadius={"9px"}
              bgcolor="#F5F9FF"
            >
              <Typography
                p="10px"
                color="var(--emr-darkblue)"
                fontWeight={"bold"}
              >
                گروه ها
              </Typography>
              <GroupTableOnline
                setDataDrugSelect={setDataDrugSelect}
                dataDrugSelect={dataDrugSelect}
                rowData={dataGroups}
                equipment={equipment}
                notGroup={notGroup}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
